module.exports = __webpack_public_path__ + "img/Vector.41ac404f.svg";